<!--{{filteredOptions | json}}-->
<div class="counter d-flex align-items-center flex-wrap">
  <button class="me-4 px-0 py-0 btn btn-bg-none btn-counter btn-counter--decrease" type="button" (click)="decrement()" [disabled]="!counterValue || counterValue < 1">
    <span class="svg-icon svg-icon2 btn-plus-minus" [inlineSVG]="STRING_CONSTANTS.ICON.IC_MINUS"></span>
  </button>

  <fieldset class="input-group col mx-4 mw-100px" [disabled]="inputShouldDisabled()">
    <input
      class="form-control form-control-solid form-input-qtt text-center"
      placeholder="0"
      minlength="1"
      type="text"
      appNumberInputLegacy
      [formControl]="counter"
      (keyup)="handleChangeInput()"
    />
  </fieldset>

  <button class="me-4 px-0 py-0 btn btn-bg-none btn-counter btn-counter--increase" type="button" (click)="increment()" [disabled]="buttonAddShouldDisabled()">
    <span class="svg-icon svg-icon2 btn-plus-minus" [inlineSVG]="STRING_CONSTANTS.ICON.IC_PLUS_BLACK"></span>
  </button>
</div>
